import React from "react";
import { Card, Stack, Text, CardProps, SimpleGrid, GroupProps } from "@mantine/core";

interface CardItem {
  icon: React.ElementType;
  iconColor: string;
  label: string;
  subLabel: string;
  color: string;
}

interface BenchMiniCardProps extends GroupProps {
  carddatas: { details: CardItem[] };
  cardWidth?: number;
  cardHeight?: number;
  iconSize?: number;
  cardProps?: CardProps;
}

const BenchMiniCard: React.FC<BenchMiniCardProps> = ({
  carddatas,
  cardWidth = 130,
  cardHeight = 90,
  iconSize = 18,
  cardProps = {},
  ...groupProps // capture all other props like m, style, etc.
}) => {
  return (
    <SimpleGrid
      cols={5}
      spacing="lg"
      breakpoints={[
        { maxWidth: 1024, cols: 3, spacing: "md" },
        { maxWidth: 768, cols: 2, spacing: "sm" },
        { maxWidth: 480, cols: 1, spacing: "sm" },
      ]}
      {...groupProps} // pass all other props to SimpleGrid
    >
      {carddatas.details.map((item, index) => {
        const Icon = item.icon;
        return (
          <Card
            key={index}
            withBorder
            radius="lg"
            p="md"
            {...cardProps} // apply all passed Card props
            style={{
              backgroundColor: item.color,
              width: 150, // fill grid column
              height: cardHeight,
              textAlign: "center",
            }}
          >
            <Stack align="center" spacing={4}>
              <Icon size={iconSize} color={item.iconColor} />
              <Text fw={600} size="sm" color="black">
                {item.label}
              </Text>
              <Text size="xs" c="dimmed">
                {item.subLabel}
              </Text>
            </Stack>
          </Card>
        );
      })}
    </SimpleGrid>
  );
};

export default BenchMiniCard;
